"use client"

import { LogoInput } from "@/components/logo-input"
import { Aurora } from "@/components/generals/aurora"

const FORMATS = ["PNG", "SVG", "PDF", "EPS"]

export default function Hero() {
  return (
    <section id="hero" className="relative isolate overflow-hidden">
      {/* The brand field. Paper at the top, full Modulify colour by the bottom. */}
      <Aurora fadeBottom />

      <div className="container relative py-16 md:py-20 lg:py-24">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <h1 className="type-display text-balance">
            Describe your brand.
            <br />
            Leave with the files.
          </h1>

          <p className="mt-6 max-w-xl text-lead text-ink text-pretty">
            One sentence about your business is enough. You get a finished mark, then the
            print-ready vector files to go with it.
          </p>

          <div className="mt-12 w-full">
            <LogoInput />
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-x-3 gap-y-2">
            <span className="text-caption font-medium text-ink">You leave with</span>
            <ul className="flex flex-wrap items-center gap-2">
              {FORMATS.map((format) => (
                <li
                  key={format}
                  className="rounded-full border border-line bg-surface/70 px-3 py-1 text-caption font-medium tabular-nums text-ink backdrop-blur-sm"
                >
                  {format}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}
